import { colors } from '@/styles'
import { ChevronLeft } from '@/components/icons'
import { CustomBackButton } from '@/components/page-title'
import BackButton from '@/components/button/back-button'

const MobileBackButton = ({ handleClickBack }: { handleClickBack: () => void }) => {
  return (
    <CustomBackButton>
      <BackButton
        color={colors.black}
        gap="4px"
        fontSize="12px"
        onClick={handleClickBack}
        Icon={ChevronLeft}
        padding="0"
      />
    </CustomBackButton>
  )
}

export default MobileBackButton
